import { render, staticRenderFns } from "./AlterCmp.vue?vue&type=template&id=b20852ca&"
import script from "./AlterCmp.vue?vue&type=script&lang=js&"
export * from "./AlterCmp.vue?vue&type=script&lang=js&"
import style0 from "./AlterCmp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports